import React from 'react'

import monthlySavings from '../../lib/calculations/monthlySavings'
import monthlyExpenses from '../../lib/calculations/monthlyExpenses'
import monthlyIncome from '../../lib/calculations/monthlyIncome'
import annualExpenses from '../../lib/calculations/annualExpenses'
import Row from './Row'

export default ({ form }) => (
  <div>
    <Row
      label='Total monthly income'
      value={monthlyIncome(form)}
    />
    <Row
      label='Total monthly expenses'
      value={monthlyExpenses(form)}
    />
    <Row
      label='Total annual expenses'
      value={annualExpenses(form) / 12}
      yearly={annualExpenses(form)}
    />
    <Row
      label='Total monthly savings'
      value={monthlySavings(form)}
      noTopLine
    />
  </div>
)
